import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react'
import { cleanParams } from 'shared/helpers/cleanParams'
import { TokenStorage } from 'shared/libs/storage/tokenStorage'
import { apiEndpoints } from 'shared/model/apiEndpoints'
import { RouterPages } from 'shared/model/routes'

// import { handleErrorNotification } from 'shared/libs/form/handle-form-error'
import { destroyAuth } from '../slices/auth'

import { baseFetchQuery } from './baseFetchQuery'

interface StringMessageResult {
  message: string
}

interface DetailedMessageResult {
  message: {
    error_code: string
    title: string
    description: string
  }
}

interface FieldErrorsMessageResult {
  message: Record<string, string[]>
}

type ErrorResult =
  | StringMessageResult
  | DetailedMessageResult
  | FieldErrorsMessageResult

export function errorHandler(result: ErrorResult): string {
  if (!result || !result.message) {
    return 'Произошло неизвестная ошибка.'
  }

  const { message } = result

  if (typeof message === 'string') {
    return message
  }

  if (
    'error_code' in message &&
    'title' in message &&
    'description' in message
  ) {
    return message.description as string
  }

  if (typeof message === 'object') {
    return Object.entries(message)
      .map(([field, errors]) => `${field}: ${errors.join(', ')}`)
      .join('\n')
  }

  return 'Unrecognized error format.'
}
const fetchBaseQueryAxios: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  if (typeof args !== 'string' && args.params) {
    args = {
      ...args,
      params: cleanParams(args.params),
    }
  }
  const result = await baseFetchQuery(args, api, extraOptions)
  if (result.error && result.meta?.response?.status === 500) {
    window.location.href = RouterPages.someWrong
  }

  if (
    result?.error?.status === 401 &&
    (typeof args === 'string' || args.url !== apiEndpoints.login)
  ) {
    api.dispatch(destroyAuth())
    TokenStorage.deleteStorage()
    window.location.href = RouterPages.login
  }

  return result
}

export default fetchBaseQueryAxios
